module.exports = __webpack_public_path__ + "static/media/DubaiW23-Regular.ed0f2585.woff";